<template>
  <div class="type-payment-row">
    <div class="type-payment-row-checkbox">
      <b-form-checkbox :checked="selected" @change="$emit('select', typePayment)" />
    </div>

    <div class="type-payment-row-name" @click="$emit('edit', typePayment)">{{ typePayment.name }}</div>

    <div class="type-payment-row-actions">
      <Tooltip title="Editar Tipo de Pagamento">
        <span class="type-payment-row-btn" @click="$emit('edit', typePayment)">
          <i class="fa-solid fa-pen-to-square"></i>
        </span>
      </Tooltip>
    </div>
  </div>
</template>

<script>
import Tooltip from "@/ui/layout/Tooltip";

export default {
  name: "TypePaymentRow",
  components: { Tooltip },
  props: {
    typePayment: {
      type: Object,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.type-payment-row {
  display: grid;
  grid-template-columns: 40px 1fr 40px;
  align-items: center;
  gap: 32px;
  padding: 18px 0;
  border-top: 1px solid var(--border-subtle);
  box-sizing: border-box;
  transition: background 0.15s;
}

.type-payment-row:hover {
  background: var(--bg-hover);
}

.type-payment-row-checkbox {
  display: flex;
  align-items: center;
}

.type-payment-row-name {
  font-size: 14px;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  transition: color 0.15s;
}

.type-payment-row-name:hover {
  color: var(--color-brand);
}

.type-payment-row-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.type-payment-row-btn {
  font-size: 16px;
  cursor: pointer;
  color: var(--text-muted);
  transition: color 0.15s;
}

.type-payment-row-btn:hover {
  color: var(--color-brand);
}

@media (max-width: 768px) {
  .type-payment-row {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
  }

  .type-payment-row-name {
    flex: 1 1 auto;
    min-width: 0;
  }
}
</style>
